const ACTION_TYPES = {
    SHOW_PREVIOUS_SEARCH: 'SHOW_PREVIOUS_SEARCH',
    HIDE_SEARCH_RESULTS: 'HIDE_SEARCH_RESULTS',
    SHOW_SEARCH_RESULTS: 'SHOW_SEARCH_RESULTS',
    REFRESH_SEARCH_RESULTS: 'REFRESH_SEARCH_RESULTS'
};

const initialState = {
    focus: false,
    keyword: null
};

const reducer = function (state = initialState, action) {
    let newVal;
    switch (action.type) {
        case ACTION_TYPES.SHOW_PREVIOUS_SEARCH:
            return Object.assign({}, state, {
                results: action.results,
                focus: true
            });
        case ACTION_TYPES.HIDE_SEARCH_RESULTS:
            return Object.assign({}, state, { focus: false });
        case ACTION_TYPES.SHOW_SEARCH_RESULTS:
            return Object.assign({}, state, {
                results: action.results,
                keyword: action.keyword,
                focus: true
            });
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
